import React from 'react';
import { Link } from 'gatsby';
import { get } from 'lodash-es';
import Img from 'gatsby-image';
import { getAuthorsFromPost } from '../../helpers/contentFilter';
import useAuthorPlaceholderImage from '../../graphql/staticQueries/useAuthorPlaceholderImage';
import { getPrimaryTag } from '../../helpers/util';

const HomeKnowledgeCard = ({ post }) => {
  const defaultImg = useAuthorPlaceholderImage().fixed;
  const authors = getAuthorsFromPost(post);
  const primaryTag = getPrimaryTag(post.frontmatter.tags).toUpperCase();
  return (
    <div className="swiper-slide" key={post.id} draggable={false}>
      <div className="top-beam">
        <div className="author">
          {authors.map((author, idx) => {
            const authorImage = get(
              author,
              'frontmatter.profileImageFixed.childImageSharp.fixed',
              defaultImg
            );
            const className = `face-img-container ${
              idx === 0 ? '' : 'face-img-container--secondary'
              }`;
            const zIndex = authors.length - idx;
            const left = `${idx * 30}px`;
            return (
              <div
                className={className}
                style={{ zIndex, left }}
                key={author.fields.url}
              >
                <Img
                  key={author.fields.url}
                  fixed={authorImage}
                  alt={author.fields.url}
                  title={author.fields.url}
                />
              </div>
            );
          })}
        </div>
        <div className="read">
          <span>{post.timeToRead} min read</span>
        </div>
      </div>
      <div className="content">
        <div className="sub-tt">{primaryTag}</div>
        <h4 className="tt">
          <Link to={post.fields.url}>{post.frontmatter.title}</Link>
        </h4>
        <div className="dd">{post.excerpt}</div>
      </div>
      <Link to={post.fields.url} className="read-more">
        Read more
      </Link>
    </div>
  );
};

export default HomeKnowledgeCard;
